import { Group, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setRelatedTasksSelectedTeam } from '../../../../../store/strategy-store/strategy-store.actions';
import { inkLight, secondaryBase } from '../../../../../styles/design-tokens';
import { Divider } from '../../../../../ui-library/divider/divider';
import { Radio } from '../../../../../ui-library/radio/radio';
import { Text } from '../../../../../ui-library/typography/typography';
import { useContributingTeams } from '../../initiative-performance.hooks';

export const FiltersTeams = () => {
  const i18n = useTranslation();
  const teams = useContributingTeams();
  const selectedTeam = useRelatedTasksTabStore((state) => state.selectedTeam);

  return (
    <Stack>
      {teams.length > 0 && (
        <>
          <Group justify="space-between">
            <Radio
              key="all-teams"
              label={<Text size="small">{i18n.t('strategy.filters.all_teams')}</Text>}
              checked={selectedTeam === null}
              onChange={() => setRelatedTasksSelectedTeam(null)}
            />
            <Text size="small" color={inkLight}>
              {teams.length}
            </Text>
          </Group>
          <Divider />
        </>
      )}
      <Stack gap={24}>
        {teams.map((team) => (
          <Stack gap={8} key={team.id}>
            <Group justify="space-between">
              <Radio
                label={
                  <Text size="small" color={secondaryBase} style={{ lineHeight: '20px' }}>
                    {team.name}
                  </Text>
                }
                checked={team.id === selectedTeam}
                onChange={() => setRelatedTasksSelectedTeam(team.id)}
              />
            </Group>
          </Stack>
        ))}
      </Stack>
      {teams.length === 0 && (
        <Text size="small" color="dimmed">
          {i18n.t('strategy.filters.no_teams_found')}
        </Text>
      )}
    </Stack>
  );
};
